import { type } from "@/api/arktype";

const sendMode = type.enumerated("dry_run", "real");
const sendOutcome = type.enumerated("sent", "simulated", "blocked", "pending");

export const SystemSchemas = {
	sendAudit: type({
		"mode?": sendMode,
		"outcome?": sendOutcome,
		"since?": "string.date.iso.parse",
		"until?": "string.date.iso.parse",
		page: "number.integer >= 1 = 1",
	}),
	decisions: type({
		page: "number.integer >= 1 = 1",
	}),
	guidanceProposal: type({
		content: type("string.trim").to("string > 0"),
		feedback_event_ids: type("number.integer > 0").array().atLeastLength(2),
	}),
	guidanceReview: type({
		id: "number.integer > 0",
		status: type.enumerated("approved", "rejected"),
		review_note: type("string.trim").to("string > 0").or("null"),
	}),
};

export type SendAuditInput = typeof SystemSchemas.sendAudit.infer;
export type DecisionsInput = typeof SystemSchemas.decisions.infer;
